import React, { PropsWithChildren } from 'react'
import Styles from './ActionsContainer.module.scss'

/**
 * Here you can put multiple buttons to share the same disposition layout
 **/
export default function ActionsContainer({ children }: PropsWithChildren) {
  return <div className={Styles.actions}>{children}</div>
}
